<template>
  <div class="">
    <div :style="{visibility: isSmallScreen ? 'hidden' :  'visible'}" class="absolute absolute-center">
      <div class="relative">
        <search-bar-component
          @openModal="openSearchModal"
          @closeModal="closeSearchModal"
          @results="(res) => updateSearchResults(res)"
          @isLoading="(loading) => isLoading = loading"
          :isSmallScreen="isSmallScreen"
        ></search-bar-component>
      </div>
    </div>
    <div @click.self="closeSearchModal" v-if="openModal" class="search-modal">
      <search-results
          @closeModal="closeSearchModal"
          @results="(res) => updateSearchResults(res)"
          :results="results"
          @isLoading="(loading) => isLoading = loading"
          :is-loading="isLoading"
          :isSmallScreen="isSmallScreen"
          :class="this.query.length ? '' : 'collapsed'"
      ></search-results>
    </div>
  </div>
</template>

<script>
import SearchResults from './SearchResults.vue';
import SearchBarComponent from './SearchBarComponent.vue';

export default {
  name: "SearchBarWrapperComponent",
  props: {
    isSmallScreen: Boolean,
  },
  components: {
    SearchResults, SearchBarComponent
  },
  data() {
    return {
      query: '',
      timer: null,
      isLoading: false,
      openModal: false,
      results: null,
    }
  },
  methods: {
    openSearchModal() {
      this.openModal = true;
    },
    closeSearchModal() {
      this.openModal = false;
    },
    updateSearchResults(results) {
      this.results = results;
    },
  }
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "~@/_default.scss";

.absolute-center {
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  transition: left 0.2s ease-in-out;
}
body.has-sidebar:not(.collapsed-sidebar) .absolute-center{
  left: calc(50% - 120px);
}
body.has-sidebar.collapsed-sidebar .absolute-center{
  left: calc(50% - 25px);
}

.search-modal {
  z-index: 10;
  position: fixed;
  width: 100%;
  top: $navbar-height;
  height: 100vh;
  left: 0;
  right: 0;
  background-color: rgba(30, 30, 30, 0.5);
  display: flex;
  place-content: center;
  align-items: center;
}

.z-auto {
  z-index: auto;
}
</style>
